import { Api } from '../api/root-api';
import {
  ReinviteRequest,
  RevokeRequest,
  TeamMember,
  TeamMembersResponse,
  TeamInvitesRequest,
  UpdateRoleRequest,
  UpdateTeamInvitesRequest,
  UpdateTeamInviteResponse,
  RolesAndPermissionsRequest,
  RoleByIDsRequest,
  RoleByIDsResponse,
  RolesAndPermissionsResponse,
  UpdateTeamEmailRequest,
  UpdateTeamEmailResponse,
  UpdateTeamMobileNumberResponse,
  UpdateTeamMobileNumberRequest,
  GetCustomersResponse,
  GetCustomersRequest,
  TeamMembersRequest,
  teamsSearchResponse,
  teamsSearchRequest,
  GetTeamMemberDetailRequest,
  GetTeamMemberDetailResponse,
  AddPrincipalUserRequest,
  AddPrincipalUserResponse,
  DeleteTeaMemberRequest,
  DeleteTeamMemberResponse,
  GetPrincipalUserResponse,
  UpdateTeamMemberCfaInviteResponse,
  UpdateTeamMemberCfaInviteRequest,
  GetDepartmentsRequest,
  GetDepartmentsResponse,
  CreateOrUpdateDepartmentRequest,
  CreateOrUpdateDepartmentResponse,
  DeleteDepartmentRequest,
  DeleteDepartmentResponse,
} from './model';
import { sentTeamInvitesSlice } from './slice';

export const sentTeamsInvitesApi = Api.injectEndpoints({
  // tagTypes: [''],
  endpoints: (builder) => ({
    getChannelMembersSentInvite: builder.query<
      TeamMembersResponse,
      TeamMembersRequest
    >({
      query: (args) => {
        const {
          userType,
          workspaceId,
          roleIds,
          cfaIds,
          suppressTeamMembersStoreUpdate,
          ...rest
        } = args;
        const params = new URLSearchParams();

        if (workspaceId) params.append('sellerWorkspaceId', workspaceId);
        Object.entries(rest).forEach(([key, value]) => {
          if (typeof value !== 'undefined') {
            params.append(key, String(value));
          }
        });

        userType?.forEach((type) => params.append('userType', type));
        roleIds?.forEach((id) => params.append('roleIds', id));
        cfaIds?.forEach((id) => params.append('cfaIds', id));

        return {
          url: `hub/orgs/api/team/list?${params.toString()}`,
          method: 'GET',
          cache: 'no-cache',
        };
      },
      providesTags: ['TeamInvites', 'teamMemberList'],

      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        if (request?.suppressTeamMembersStoreUpdate) return;
        queryFulfilled
          .then((response) => {
            dispatch(
              sentTeamInvitesSlice.actions.updateTeamMembers(
                response.data?.data
              )
            );
          })
          .catch((x) => {
            console.error(x);
          });
      },
    }),
    getDepartments: builder.query<
      GetDepartmentsResponse,
      GetDepartmentsRequest
    >({
      query: (args) => {
        const {
          sellerWorkspaceId,
          page,
          pageSize,
          searchKey,
          departmentId,
          departmentCode,
          departmentName,
        } = args;
        const params = new URLSearchParams();

        if (sellerWorkspaceId) {
          params.append('sellerWorkspaceId', sellerWorkspaceId);
        }
        if (page) {
          params.append('page', String(page));
        }
        if (pageSize) {
          params.append('pageSize', String(pageSize));
        }
        if (searchKey) {
          params.append('searchKey', searchKey);
        }
        departmentId?.forEach((id) => params.append('departmentId', id));
        departmentCode?.forEach((code) =>
          params.append('departmentCode', code)
        );
        departmentName?.forEach((name) =>
          params.append('departmentName', name)
        );

        return {
          url: `hub/orgs/api/department?${params.toString()}`,
          method: 'GET',
          cache: 'no-cache',
        };
      },
      providesTags: ['teamMemberList', 'departmentList'],
    }),
    createOrUpdateDepartment: builder.mutation<
      CreateOrUpdateDepartmentResponse,
      CreateOrUpdateDepartmentRequest
    >({
      query: (args) => {
        const params = new URLSearchParams();
        if (args?.sellerWorkspaceId) {
          params.append('sellerWorkspaceId', args.sellerWorkspaceId);
        }
        return {
          url: `hub/orgs/api/department?${params.toString()}`,
          method: 'POST',
          body: args.body,
        };
      },
      invalidatesTags: ['departmentList'],
    }),
    deleteDepartment: builder.mutation<
      DeleteDepartmentResponse,
      DeleteDepartmentRequest
    >({
      query: (args) => {
        const params = new URLSearchParams();
        if (args?.sellerWorkspaceId) {
          params.append('sellerWorkspaceId', args.sellerWorkspaceId);
        }
        return {
          url: `hub/orgs/api/department/${args.departmentId}?${params.toString()}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['departmentList'],
    }),
    teamsSearch: builder.query<teamsSearchResponse[], teamsSearchRequest>({
      query(args) {
        return {
          url: 'teams/members/search',
          method: 'GET',
          params: args,
        };
      },
    }),
    sendTeamMemberInvite: builder.mutation<TeamMember[], TeamInvitesRequest>({
      query(params) {
        return {
          url: `send/teaminvites`,
          method: 'POST',
          body: params,
        };
      },
    }),
    updateTeamMemberCfaInvite: builder.mutation<
      UpdateTeamMemberCfaInviteResponse[],
      UpdateTeamMemberCfaInviteRequest
    >({
      query(params) {
        return {
          url: `teamMember/cfa/assign`,
          method: 'POST',
          body: params,
        };
      },
    }),
    updateTeamMemberInvite: builder.mutation<
      UpdateTeamInviteResponse,
      UpdateTeamInvitesRequest
    >({
      query(params) {
        return {
          url: `teamMember/create`,
          method: 'POST',
          body: params,
        };
      },
      invalidatesTags: ['TeamInvites'],
    }),
    deleteTeamMember: builder.mutation<
      DeleteTeamMemberResponse,
      DeleteTeaMemberRequest
    >({
      query(args) {
        return {
          url: `hub/orgs/api/team/${args.teamId}`,
          method: 'DELETE',
          params: args.params,
        };
      },
    }),
    addSupportUser: builder.mutation<any, any>({
      query(params) {
        return {
          url: `admin/user`,
          method: 'POST',
          body: params,
        };
      },
    }),
    getSupportUser: builder.query<any, any>({
      query(args) {
        return {
          url: `/admin/user/${args?.supportUserId}`,
          method: 'GET',
        };
      },
    }),
    updateSupportUser: builder.mutation<any, any>({
      query(params) {
        return {
          url: `/admin/user/edit`,
          method: 'POST',
          body: params,
        };
      },
    }),

    inactiveSupportUser: builder.mutation<any, any>({
      query(params) {
        return {
          url: `/admin/user/status`,
          method: 'POST',
          body: params,
        };
      },
    }),
    updateCustomer: builder.mutation<any, any>({
      query(params) {
        return {
          url: `admin/user/assign-roles`,
          method: 'POST',
          body: params,
        };
      },
    }),
    updateInviteStatus: builder.mutation<string, string>({
      query(id) {
        return {
          url: `teams/${id}`,
          method: 'PUT',
          body: { status: 'P' },
          responseHandler: (response) => response.text(),
        };
      },
    }),
    reinviteTeamMember: builder.mutation<string, ReinviteRequest>({
      query(args) {
        return {
          url: 'teams/reinvite',
          method: 'POST',
          body: args,
          responseHandler: (response) => response.text(),
        };
      },
    }),
    revokeTeamMember: builder.mutation<string, RevokeRequest>({
      query(args) {
        return {
          url: 'workspaces/members/revoke',
          method: 'POST',
          body: args,
          responseHandler: (response) => response.text(),
        };
      },
    }),
    updateTeamMemberRole: builder.mutation<string, UpdateRoleRequest>({
      query(args) {
        return {
          url: 'workspaces/members/role',
          method: 'POST',
          body: args,
          responseHandler: (response) => response.text(),
        };
      },
    }),
    getRolesAndPermissions: builder.query<
      RolesAndPermissionsResponse,
      RolesAndPermissionsRequest
    >({
      query(args) {
        return {
          url: 'workspaces/roles/permissions',
          method: 'GET',
          params: args,
        };
      },
    }),
    getCustomers: builder.query<GetCustomersResponse, GetCustomersRequest>({
      query(args) {
        return {
          url: 'admin/workspaces',
          method: 'GET',
          params: args,
        };
      },
    }),
    getPrincipalUser: builder.query<GetPrincipalUserResponse, any>({
      query(args) {
        return {
          url: `admin/workspace/details/${args?.principalUserId}`,
          method: 'GET',
        };
      },
    }),
    updatePrincipalUser: builder.mutation<any, any>({
      query(args) {
        return {
          url: `admin/workspace/details/update`,
          method: 'POST',
          body: args?.payload,
        };
      },
    }),
    deleteCustomer: builder.mutation<any, { id: string }>({
      query: (args) => {
        return {
          url: `admin/user/delete/${args.id}`,
          method: 'DELETE',
        };
      },
    }),
    getRoleByIDs: builder.mutation<RoleByIDsResponse, RoleByIDsRequest>({
      query(args) {
        return {
          url: 'workspaces/roles/permission/list',
          method: 'POST',
          body: args,
        };
      },
    }),
    updateTeamEmail: builder.mutation<
      UpdateTeamEmailResponse,
      UpdateTeamEmailRequest
    >({
      query(args) {
        return {
          url: 'teams/update/email',
          method: 'POST',
          body: args,
        };
      },
      invalidatesTags: ['TeamInvites'],
    }),
    updateTeamMobile: builder.mutation<
      UpdateTeamMobileNumberResponse,
      UpdateTeamMobileNumberRequest
    >({
      query(args) {
        return {
          url: 'teams/update/mobile',
          method: 'POST',
          body: args,
        };
      },
      invalidatesTags: ['TeamInvites'],
    }),
    getTeamMemberDetail: builder.query<
      GetTeamMemberDetailResponse,
      GetTeamMemberDetailRequest
    >({
      query(arg) {
        return {
          url: `hub/orgs/api/team/details/${arg.sellerWorkspaceId}?teamMemberId=${arg.teamMemberId}&sellerWorkspaceId=${arg.sellerWorkspaceId}`,
          method: 'get',
        };
      },
    }),
    cretePrincipalUser: builder.mutation<
      AddPrincipalUserResponse,
      AddPrincipalUserRequest
    >({
      query(args) {
        return {
          url: 'seller/admin/self-onboarding',
          method: 'POST',
          body: args,
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useLazyGetChannelMembersSentInviteQuery,
  useSendTeamMemberInviteMutation,
  useUpdateInviteStatusMutation,
  useReinviteTeamMemberMutation,
  useRevokeTeamMemberMutation,
  useUpdateTeamMemberRoleMutation,
  useUpdateTeamMemberInviteMutation,
  useUpdateTeamMemberCfaInviteMutation,
  useUpdateCustomerMutation,
  useAddSupportUserMutation,
  useInactiveSupportUserMutation,
  useDeleteCustomerMutation,
  useLazyGetRolesAndPermissionsQuery,
  useGetRoleByIDsMutation,
  useLazyGetCustomersQuery,
  useUpdateTeamEmailMutation,
  useUpdateTeamMobileMutation,
  useLazyTeamsSearchQuery,
  useLazyGetTeamMemberDetailQuery,
  useCretePrincipalUserMutation,
  useDeleteTeamMemberMutation,
  useLazyGetPrincipalUserQuery,
  useUpdatePrincipalUserMutation,
  useLazyGetSupportUserQuery,
  useUpdateSupportUserMutation,
  useLazyGetDepartmentsQuery,
  useGetDepartmentsQuery,
  useCreateOrUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
} = sentTeamsInvitesApi;
